import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import ExpandingTextArea from 'components/form/textarea'
import { SelectPickerField } from 'components/form/selectpicker'
import { cond, complement, always, replace, pipe, both, has } from 'ramda'
import withFieldError from 'components/form/with-error'

const endpointPlaceholder = `{ // valid json }

{
  "body": { // JSON body },
}

- Or -

{
  "form": { // Form values }
}

`
export const UrlInput = ({ input, type, label, meta: { touched, error } }) => (
  <div>
    <input
      className={
        'form-control right-element-no-borders ' +
        (error && touched ? 'has-error' : '')
      }
      {...input}
      type={type}
      placeholder={label}
    />
  </div>
)

UrlInput.propTypes = {
  input: PropTypes.any,
  type: PropTypes.string,
  label: PropTypes.string,
  meta: PropTypes.any
}

export const UrlInputWithError = withFieldError(UrlInput)

const isValidUrl = string => {
  var pattern = /(http(s)?):\/\/[a-z0-9]+/gi
  return !!pattern.exec(string)
}

export const validateUrl = cond([
  [complement(isValidUrl), always('Please enter a valid URL')]
])

export const CustomTextArea = ({ input, meta: { error, touched } }) => (
  <div>
    <ExpandingTextArea
      className={
        'form-control custom-text-area ' + (error && touched ? 'has-error' : '')
      }
      placeholder={endpointPlaceholder}
      label='Tweet Message'
      {...input}
    />
  </div>
)

CustomTextArea.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const CustomTextAreaWithError = withFieldError(CustomTextArea)

export function validateJson (value) {
  // matches all merge fields (${}) that are not surrounded by quotes
  // for example '"${one}" ${two}
  // will match '${two}'
  const mergeFields = /(?:[^"])(\${\w+})/gi

  // wraps the selected values with double quotes ("")
  // some merge fields translate to valid JSON
  // so we must allow them when testing for validity
  const wrapMergeFields = replace(mergeFields, '"$1"')

  const validate = pipe(wrapMergeFields, JSON.parse)

  try {
    validate(value)
  } catch (error) {
    return 'Please enter valid JSON'
  }

  const validatedJson = validate(value)
  const hasFormAndBody = both(has('form'), has('body'))(validatedJson)

  if (hasFormAndBody) return 'Body and Form parameters cannot be combined'
}

const CallEndpointFields = ({ name }) => (
  <div className='row'>
    <div className='col-sm-3 br-no-pad-right component-select-picker'>
      <Field
        name={`${name}.method`}
        component={SelectPickerField}
        defaultValue='POST'
      >
        <option value='POST'>POST</option>
        <option value='GET'>GET</option>
      </Field>
    </div>
    <div className='col-sm-9 br-no-pad-left'>
      <Field
        component={UrlInputWithError}
        type='text'
        label='Endpoint URL'
        name={`${name}.url`}
        validate={validateUrl}
      />
    </div>
    <div className='col-sm-12'>
      <Field
        name={`${name}.data`}
        component={CustomTextAreaWithError}
        validate={validateJson}
      />
    </div>
  </div>
)

CallEndpointFields.propTypes = {
  name: PropTypes.string
}

export default CallEndpointFields



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/twitter/call-endpoint/index.js